import FmBrowserTableDto from 'app/admin/fileManager/dto/FmBrowserTableDto';
import FmDirectoryCurrentDto from 'app/admin/fileManager/dto/FmDirectoryCurrentDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import FileResultDto from 'modules/base/dto/file/FileResultDto';
import nBossConnection from 'modules/base/service/nBossConnection';

class FmBrowserTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'fmBrowserTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<FmBrowserTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, FmBrowserTableDto)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {number} storageId
	 * @return {Promise<FmDirectoryCurrentDto>}
	 */
	getCurrent(id, storageId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getCurrent`, {
					id,
					storageId
				})
				.then(response => resolve(new FmDirectoryCurrentDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {string} key
	 * @return {Promise<FileResultDto>}
	 */
	getInfo(key) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getInfo`, {
					key
				})
				.then(response => resolve(new FileResultDto().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new FmBrowserTableService();
